import { Input, Modal, ModalBody } from "reactstrap";
import styles from "./index.module.scss";

const DeleteConfirmation = (props) => {
  const { open, setOpen, handleConfirmDelete } = props;
  return (
    <Modal
      isOpen={open}
      toggle={setOpen}
      backdrop
      size="sm"
      backdropClassName={styles["reverted-backdrop"]}
      className={styles["supporter-registration-modal"]}
      style={{
        width: "440px",
      }}
    >
      <ModalBody>
        <div
          style={{
            fontSize: "20px",
            marginBottom: "20px",
            textAlign: "center",
            marginTop: "72px",
          }}
        >
          条件変更
        </div>
        <div>
          <div
            style={{
              fontSize: "20px",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            削除してもよろしいですか？
          </div>
          <div
            style={{
              marginBottom: "100px",
              display: "flex",
              justifyContent: "center",
              alignItem: "center",
            }}
          >
            <button
              style={{
                marginTop: "16px",

                padding: "12px 20px",
                backgroundColor: "#FFBCBA",
                border: "1px solid #CD433E",
                color: "#CD433E",
                borderRadius: "8px",
              }}
              onClick={handleConfirmDelete}
            >
              削除
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteConfirmation;
